'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../providers/ClaimBuilder/index.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Markdown = require('../../components/Markdown/Markdown.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ItemSelectionItemIneligibleReason = _ref => {
  let {
    item,
    packageId
  } = _ref;
  const {
    getFullItemDetails
  } = index.useClaimBuilder();
  const {
    claimsIneligibilityItemPackageBeingReturned,
    claimsIneligibilityItemMaxClaimed,
    claimsIneligibilityItemClaimed,
    claimsIneligibilityItemNotEligible,
    claimsIneligibilityItemReturned,
    claimsIneligibilityItemReturnedOrClaimed,
    claimsIneligibilityItemTooEarly,
    claimsIneligibilityItemDeliveredTooEarly,
    claimsIneligibilityItemTooLate,
    claimsIneligibilityBopisItemNotEligible,
    claimsIneligibilityNoMultiPackageClaimsItem,
    claimsIneligibilityItemPackageNotDeliveredTooLate,
    claimsIneligibilityItemNoEligibleItems
  } = nthHookTranslations.useTranslations();
  const eligibilityReasonText = {
    PackageBeingReturned: claimsIneligibilityItemPackageBeingReturned ?? '',
    PackageNotDeliveredTooLate: claimsIneligibilityItemPackageNotDeliveredTooLate ?? '',
    NoEligibleItems: claimsIneligibilityItemNoEligibleItems ?? '',
    TooEarly: claimsIneligibilityItemTooEarly ?? '',
    DeliveredTooEarly: claimsIneligibilityItemDeliveredTooEarly ?? '',
    TooLate: claimsIneligibilityItemTooLate ?? '',
    ItemClaimed: claimsIneligibilityItemClaimed ?? '',
    ItemReturned: claimsIneligibilityItemReturned ?? '',
    ItemReturnedOrClaimed: claimsIneligibilityItemReturnedOrClaimed ?? '',
    ItemNotEligible: claimsIneligibilityItemNotEligible ?? '',
    BopisItemNotEligible: claimsIneligibilityBopisItemNotEligible ?? '',
    // Dynamic values
    MaxClaimableQuantityReached: claimsIneligibilityItemMaxClaimed ?? '',
    SinglePackageClaimRestriction: claimsIneligibilityNoMultiPackageClaimsItem ?? ''
  };
  const itemDetails = getFullItemDetails(item.itemRefId, packageId);
  if (!itemDetails) throw new Error('Insufficient item details');
  const {
    ineligibilityReason,
    ineligibilityReasonMessage
  } = itemDetails.evaluatedEligibility;
  const reason = ineligibilityReasonMessage || ineligibilityReason && eligibilityReasonText[ineligibilityReason];
  return reason ? /*#__PURE__*/React__default["default"].createElement(Markdown["default"], {
    markdown: reason
  }) : null;
};
var ItemSelectionItemIneligibleReason$1 = nthHookTranslations.withTranslationsProvider(ItemSelectionItemIneligibleReason, {
  translationKeys: ['claimsIneligibilityItemPackageBeingReturned', 'claimsIneligibilityItemMaxClaimed', 'claimsIneligibilityItemClaimed', 'claimsIneligibilityItemNotEligible', 'claimsIneligibilityItemReturned', 'claimsIneligibilityItemReturnedOrClaimed', 'claimsIneligibilityBopisItemNotEligible', 'claimsIneligibilityItemTooEarly', 'claimsIneligibilityItemDeliveredTooEarly', 'claimsIneligibilityItemTooLate', 'claimsIneligibilityNoMultiPackageClaimsItem', 'claimsIneligibilityItemPackageNotDeliveredTooLate', 'claimsIneligibilityItemNoEligibleItems']
});

exports["default"] = ItemSelectionItemIneligibleReason$1;
